import {
  getCoreRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table'

const CreateTableState = ({ ...rest }, data = []) =>
  useReactTable({
    data,
    enableHiding: true,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(), //client-side sorting
    getExpandedRowModel: getExpandedRowModel(),
    defaultColumn: rest.defaultColumn || {
      minSize: 0,
      size: 0,
    },
    ...rest,
  })

export default CreateTableState
